import { createEffect, sample } from 'effector';
import { webSocketConnectionStuck } from './logger';
import { STREAM_CHAT_MODEL } from './stream-chat-model';

const closeFx = createEffect(() => STREAM_CHAT_MODEL.client.closeConnection());
const openFx = createEffect(() => STREAM_CHAT_MODEL.client.openConnection());

const restartFx = createEffect(async () => {
  await closeFx();
  await openFx();
});

sample({
  clock: restartFx.failData,
  target: createEffect(console.error),
});

sample({
  clock: webSocketConnectionStuck,
  target: restartFx,
});
